export { default as LooselyLoadableWrapper } from './loosely-loadable-wrapper';
export type { Options, LooselyLoadableLoadingComponentProps } from './types';
